module.exports = __webpack_public_path__ + "media/images/ajax-loader-7708997ef1f5564db44ece2f8e8d8fb4.gif";